import { useNavigate } from "@tanstack/react-router";
import { Header } from "@/app/layout/Header";
import { Main } from "@/app/layout/Main";
import { toast } from "@/components/kit";
import { ProductFormPageHeader } from "@/modules/products/presentation/ui/ProductFormPageHeader";
import { useCreateGoodsReceipt } from "../api/queries";
import { GoodsReceiptForm } from "../ui/GoodsReceiptForm";

export function ReceiveGoodsPage() {
  const nav = useNavigate();
  const create = useCreateGoodsReceipt();

  return (
    <>
      <Header />
      <Main>
        <ProductFormPageHeader
          title="ຮັບເຂົ້າສະຕັອກ"
          subtitle="ສ້າງໃບຮັບເຂົ້າ (lot) ພ້ອມຕົ້ນທຸນ + ຄ່າຂົນສົ່ງ"
          onBack={() => nav({ to: "/app/inventory" })}
        />
        <GoodsReceiptForm
          submitting={create.isPending}
          onSubmit={async (payload) => {
            try {
              const receipt = await create.mutateAsync(payload);
              toast.success("ບັນທຶກໃບຮັບເຂົ້າສຳເລັດ");
              nav({
                to: "/app/inventory/receive/$id",
                params: { id: receipt.id },
              });
            } catch {
              toast.error("ບັນທຶກລົ້ມເຫຼວ");
            }
          }}
        />
      </Main>
    </>
  );
}
